import { useNavigate } from 'react-router-dom'
import { AppBreadcrumb } from '@/components/navigation/AppBreadcrumb'
import { NotificationBell } from '@/components/layout/NotificationBell'
import { UserMenu } from '@/components/layout/UserMenu'
import { useSettingsStore } from '@/stores/settingsStore'
import logoNameDark from '@/assets/logo_name_dark.png'
import logoNameLight from '@/assets/logo_name_light.png'

/**
 * Header principal: logo + breadcrumb de navegação + menu do usuário.
 * O WorkspaceSelector foi substituído pelo AppBreadcrumb (workspace clicável).
 */
export function Header() {
  const resolvedTheme = useSettingsStore((s) => s.resolvedTheme)
  const navigate = useNavigate()

  return (
    <header
      className="flex items-center gap-2 px-3 py-1.5 shrink-0 min-h-[48px]"
      style={{ background: 'var(--bg-toolbar)', borderBottom: '1px solid var(--border)' }}
    >
      {/* Logo */}
      <button
        type="button"
        onClick={() => navigate('/')}
        aria-label="MorphERD"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          flexShrink: 0,
        }}
      >
        <img
          src={resolvedTheme === 'dark' ? logoNameDark : logoNameLight}
          alt="MorphERD"
          className="h-6 w-auto max-w-[180px]"
        />
      </button>

      {/* Separador logo / breadcrumb */}
      <span
        aria-hidden
        style={{
          width: 1,
          height: 16,
          background: 'var(--border, #232831)',
          flexShrink: 0,
          marginLeft: 4,
          marginRight: 4,
        }}
      />

      {/* Breadcrumb — cresce mas não empurra os controles direitos */}
      <div style={{ flex: '1 1 0', minWidth: 0, overflow: 'hidden' }}>
        <AppBreadcrumb />
      </div>

      {/* Controles à direita */}
      <div className="ml-auto flex items-center gap-2 shrink-0">
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  )
}
